angular.module('leanlaw').controller('BillingTrustMatterCtrl', ['$q', '$filter', '$window', '$scope', '$state', '$stateParams', 'alerts', 'userService', 'clientManager', 'matterManager', 'leanLawApi', 'leanLawAuth', function ($q, $filter, $window, $scope, $state, $stateParams, alerts, userService, clientManager, matterManager, leanLawApi, leanLawAuth) {
  var _trustAccount = null;
  $scope.trust = {
    loading: true
  };
  $scope.account = {
    loading: true
  };
  $scope.invoicesLoading = false;
  $scope.invoices = [];
  $scope.error = '';
  $scope.trustSort = 'date';
  $scope.trustReverse = true;
  $scope.invoiceSort = {
    sort: 'invoiceDate',
    reverse: false
  };
  $scope.invoiceReverse = false;
  $scope.selectAll = selectAll;
  $scope.allSelected = true;
  $scope.open = function (invoice) {
    const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
    $window.open(url);
  };
  $scope.report = function () {
    if (!_trustAccount) return;
    var url = $scope.me.configuration.quickbooks;
    url += '/app/reportv2?token=ACCTL_QUICKREPORT&date_macro=all&groupby=(Account/AccountTypeID,Account/OrderName&account=' + _trustAccount;
    $window.open(url);
  };
  $scope.invoiceSelected = () => $scope.invoices.find(i => i.pay);

  //this is not used anymore
  $scope.load = function () {
    if (!_trustAccount) return;
    $scope.transactions = {
      loading: true
    };
    leanLawApi.getAccountingAccount({
      id: _trustAccount,
      transactions: true
    }).then(processTransactions);
  };
  activate();
  $scope.pay = pay;

  ////////////////////////

  function activate() {
    if (!$stateParams.clientId && !$stateParams.matterId) {
      return $state.go('^.summary');
    }
    userService.me().then(function (me) {
      if (!me.company.settings.trustEnabled) {
        return $state.go('^.summary');
      }
      $scope.me = me;
      loadClientOrMatter($stateParams.clientId, $stateParams.matterId).catch(err => {
        $scope.error = "Failed to load trust account or invoice information. This can happen if the liability account was deleted in QuickBooks or for other reasons. Click 'Prepare Trust Account' to connect or check the account.";
        alerts.error(err);
      }).finally(() => {
        $scope.trust.loading = false;
      });
    });
  }
  function loadClientOrMatter(clientId, matterId) {
    // Gets client or matter, and returns client if matter is client billed
    if (!matterId) {
      return clientManager.get(clientId).then(loadClient);
    }
    return matterManager.get(matterId).then(function (matter) {
      if (matter.client.billing.billClient) {
        return clientManager.get(matter.client.id).then(loadClient);
      }
      return loadMatter(matter);
    });
  }
  function connect(accounting, item, state) {
    if (accounting.connect) {
      state.message = "To setup trust accounting, the " + item + " must be associated with a QuickBooks customer";
      state.onCancel = function () {
        $scope.error = "The " + item + " must be connected to a QuickBooks customer";
      };
      $scope.fail = true;
      $state.go('.connect', state);
    }
    return accounting.connect;
  }
  $scope.goToReport = function () {
    if (!$scope.matter && !$scope.client.billing.billClient) {
      alerts.warning(`Clients is set up for ${$scope.me.terms.Matter} Accounting, so can only show transactions at ${$scope.me.terms.matter} level`);
      return;
    }
    $state.go("reports.trust-detail", {
      return: "billing.trust.matter",
      clientId: $scope.client.id,
      matterId: $scope.matter ? $scope.matter.id : null,
      returnParams: {
        clientId: $scope.client.id,
        matterId: $scope.matter ? $scope.matter.id : null
      }
    });
  };
  function loadClient(client) {
    if (!client.billing.trust) {
      // Trust accounting has not been set up for this client
      return $q.resolve();
    }
    return client.getOrConnectAccounting().then(accounting => {
      if (connect(accounting, 'client', {
        clientId: client.id
      })) return;
      if (!client.billing.billClient) {
        $scope.billClientWarning = true;
        return;
      }
      $scope.client = client;
      $scope.matter = null;
      const loadTrust = leanLawApi.getClientTrust({
        id: client.id
      }).then(processTrust);
      $scope.invoicesLoading = true;
      const loadInvoices = leanLawApi.listInvoices({
        check: true,
        clientId: client.id
      }).then(processInvoices).finally(() => {
        $scope.invoicesLoading = false;
      });
      _trustAccount = client.billing.trust.account.id;
      return $q.all([loadTrust, loadInvoices]);
    });
  }
  function loadMatter(matter) {
    if (!matter.billing.trust) {
      // Trust accounting has not been set up for this client
      return $q.resolve();
    }
    return matter.getOrConnectAccounting().then(function (accounting) {
      if (connect(accounting, $scope.me.terms.matter, {
        matterId: matter.id
      })) return;
      $scope.client = matter.client;
      $scope.matter = matter;
      var loadTrust = leanLawApi.getMatterTrust({
        id: matter.id
      }).then(processTrust);
      var loadInvoices = leanLawApi.listInvoices({
        check: true,
        matterId: matter.id
      }).then(processInvoices);
      _trustAccount = matter.billing.trust.account.id;
      return $q.all([loadTrust, loadInvoices]);
    });
  }
  function processTrust(trust) {
    $scope.trust = trust;
    return leanLawApi.getAccountingClient({
      id: trust.matter ? trust.matter.accounting.id : trust.client.accounting.id
    }).then(function (account) {
      $scope.account = account;
    });
  }
  function processInvoices(list) {
    $scope.invoices = list.invoices.filter(i => i.state.open);
    $scope.invoices.forEach(i => {
      i.pay = !!i.accounting;
    });
  }
  function processTransactions(list) {
    $scope.transactions = list.transactions;
  }
  function pay() {
    var include = $scope.invoices.filter(i => i.pay);
    include = $filter('orderBy')(include, $scope.invoiceSort.sort, $scope.invoiceSort.reverse);
    var amount = _.reduce(include, (sum, i) => sum + i.state.balance, 0);
    $state.go('.payment', {
      amount: amount,
      max: $scope.trust.balance,
      invoices: include
    });
  }
  function selectAll(select) {
    $scope.invoices.forEach(invoice => {
      invoice.pay = select;
    });
  }
}]);